import { SelectItem, FieldItem } from '../../types';
import { SelectionTypeItem } from './types-fields';

export const ACTION = {
  CLEAR_GROUP_BY_STATE: 'SELECTION_REPORT:CLEAR_GROUP_BY_STATE',
  REQUEST_GROUP_BY_FIELDS: 'SELECTION_REPORT:REQUEST_GROUP_BY_FIELDS',
  RESPONSE_GROUP_BY_FIELDS: 'SELECTION_REPORT:RESPONSE_GROUP_BY_FIELDS',
  REQUEST_GROUP_BY_DEFAULT_FIELDS: 'SELECTION_REPORT:REQUEST_GROUP_BY_DEFAULT_FIELDS',
  RESPONSE_GROUP_BY_DEFAULT_FIELDS: 'SELECTION_REPORT:RESPONSE_GROUP_BY_DEFAULT_FIELDS',
  UPDATE_DEFAULT_GROUP_BY_FIELDS: 'SELECTION_REPORT:UPDATE_DEFAULT_GROUP_BY_FIELDS',
  REQUEST_GROUP_BY_SORT_ORDER_TYPE: 'SELECTION_REPORT:REQUEST_GROUP_BY_SORT_ORDER_TYPE',
  RESPONSE_GROUP_BY_SORT_ORDER_TYPE: 'SELECTION_REPORT:RESPONSE_GROUP_BY_SORT_ORDER_TYPE',
  REQUEST_GROUP_BY_SELECTION_TYPES: 'SELECTION_REPORT:REQUEST_GROUP_BY_SELECTION_TYPES',
  RESPONSE_GROUP_BY_SELECTION_TYPES: 'SELECTION_REPORT:RESPONSE_GROUP_BY_SELECTION_TYPES'
};

export class ClearGroupByState {
  public type: string = ACTION.CLEAR_GROUP_BY_STATE;
  constructor(public instanceKey: string) {}
}
export class RequestGroupByDefaultFields {
  public type: string = ACTION.REQUEST_GROUP_BY_DEFAULT_FIELDS;
  constructor(public instanceKey: string) {}
}
export class ResponseGroupByDefaultFields {
  public type: string = ACTION.RESPONSE_GROUP_BY_DEFAULT_FIELDS;
  constructor(public instanceKey: string, public options: FieldItem[]) { }
}
export class UpdateGroupByDefaultFields {
  public type: string = ACTION.UPDATE_DEFAULT_GROUP_BY_FIELDS;
  constructor(public instanceKey: string, public options: FieldItem[]) { }
}
export class RequestGroupBySortOrderType {
  public type: string = ACTION.REQUEST_GROUP_BY_SORT_ORDER_TYPE;
  constructor(public instanceKey: string) {}
}
export class ResponseGroupBySortOrderType {
  public type: string = ACTION.RESPONSE_GROUP_BY_SORT_ORDER_TYPE;
  constructor(public instanceKey: string, public options: SelectItem[]) { }
}
export class ResponseGroupByFields {
  public type: string = ACTION.RESPONSE_GROUP_BY_FIELDS;
  constructor(public instanceKey: string, public options: FieldItem[]) { }
}
export class RequestGroupBySelectionTypes {
  public type: string = ACTION.REQUEST_GROUP_BY_SELECTION_TYPES;
  constructor(public instanceKey: string, public selectionFieldId: number) { }
}
export class ResponseGroupBySelectionTypes {
  public type: string = ACTION.RESPONSE_GROUP_BY_SELECTION_TYPES;
  constructor(
    public instanceKey: string, 
    public selectionFieldId: number, 
    public selectionTypes: SelectionTypeItem[], 
    public showMissingValues: boolean) { }
}
